'use client';
import React from 'react';
import { DatePicker, Heading } from '@ui';
import { Section, Container } from '@layout';
import { withOptionalId } from '@lib/withOptionalId';
import MarkupSnippet, { markupCopyLabels } from '../markup-snippet/MarkupSnippet';

type DatePickerDemoProps = {
  sectionID?: string;
  classes?: string;
  containerId?: string;
  containerClasses?: string;
  isSpanish?: boolean;
};

const DatePickerDemo = ({
  sectionID = 'date-picker',
  classes = '',
  containerId,
  containerClasses,
  isSpanish = false,
}: DatePickerDemoProps) => {
  const t = (en: string, es: string) => (isSpanish ? es : en);

  return (
    <Section {...withOptionalId(sectionID)} className={classes}>
      <Container containerId={containerId} containerClasses={containerClasses}>
        <Heading as='h3'>{t('Date Picker', 'Selector de fecha')}</Heading>
        <p className='sub full'>
          {t('Pick a single date with “Today” and “Clear”.', 'Elige una fecha con “Hoy” y “Limpiar”.')}
        </p>
        <DatePicker id='date-picker' />
      <MarkupSnippet
          {...markupCopyLabels(isSpanish)}
          code={`<label for="date">Date</label>
<input id="date" type="date" />`}
        />
      </Container>
    </Section>
  );
};

export default DatePickerDemo;
